import { z } from 'zod'

/** The longest phone accepted, as typed — room for a country code and an extension. */
export const PHONE_MAX = 40

/**
 * A phone number as someone types it: digits with the usual + ( ) - . and spaces,
 * and at least seven digits. Kept exactly as typed (trimmed), never reformatted,
 * because the people reading it already know how their own numbers are written.
 */
export const phoneSchema = z
  .string()
  .trim()
  .max(PHONE_MAX, 'That phone number is too long.')
  .regex(/^[+()\d.\-\s]+$/, 'Enter a phone number: digits, with + ( ) - . and spaces if you like.')
  .refine((v) => v.replace(/\D/g, '').length >= 7, 'Enter a phone number with at least 7 digits.')
